<template>
  <div>
    <div class="air__utils__heading">
      <div class="row justify-content-center" v-if="pagepermission.viewable">
        <div class="col-6 col-md-6">
          <h5>Homework</h5>
        </div>
        <div class="col-6 col-md-6 text-right">
          <div class="d-inline-flex mr-2 mb-2">
            <add-homework v-if="pagepermission.insertable" @created="handleCreated"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <homework-table :data="data" :rolesetting="pagepermission" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import HomeworkTable from '@/components/homework/Table/index'
import AddHomework from '@/components/homework/Add/index'

export default {
  components: {
    HomeworkTable,
    AddHomework,
  },
  beforeMount: function() {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('homework', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.getHomework()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      search: null,
      selectedRowKeys: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getHomework: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }

      this.$http.get('/api/homework/all', {
        params: {
          limit: this.pageSize,
          page: page,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getHomework()
    },
    handleUpdateTable: function() {
      this.getHomework()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getHomework()
    },
    onChange(current) {
      this.current = current
      this.getHomework()
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
